const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/containers/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { Spinner } from '@tempo-io/sui-spinner';
import { boxesInfiniteQueryOptions } from '@/lib/queries/common/boxes/useBoxesInfiniteQuery';
import { boxesUserPermissionsInfiniteQueryOptions } from '@/lib/queries/common/boxes/useBoxesUserPermissionsInfiniteQuery';
import i18n from '@/lib/translations/i18n';
export const Route = createFileRoute('/(app)/org/$org/settings/containers/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context: {
      queryClient
    }
  }) => {
    await queryClient.ensureInfiniteQueryData(boxesInfiniteQueryOptions());
    await queryClient.ensureInfiniteQueryData(boxesUserPermissionsInfiniteQueryOptions());
  },
  pendingComponent: () => <div className="flex items-center justify-center h-full">
      <Spinner size={32} />
    </div>,
  staticData: {
    topNav: {
      title: i18n.t($ => $.common.settings.boxes.boxes)
    }
  }
});